// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { PharmacyCardFinderV2ResponseModel } from './pharmacyCardFinderV2ResponseModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class PharmacyV2CardFinderRequestResponse {
    'data': PharmacyCardFinderV2ResponseModel | null;
    'success': boolean;
    'messages': Array<string> | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof PharmacyV2CardFinderRequestResponse>> = [
        {
            "name":     "data",
            "baseName": "data",
            "type":     "PharmacyCardFinderV2ResponseModel"
        },
        {
            "name":     "success",
            "baseName": "success",
            "type":     "boolean"
        },
        {
            "name":     "messages",
            "baseName": "messages",
            "type":     "Array<string>"
        },
    ];

    static getAttributeTypeMap() {
        return PharmacyV2CardFinderRequestResponse.attributeTypeMap;
    }
}
